import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Toast from './Toast';
import ButtonRegular from './ui/ButtonRegular';
import '../styles/PageRegister.css';

const PageRegister = () => {
	const [formData, setFormData] = useState({
		email: '',
		password: '',
		confirmPassword: '',
		firstName: '',
		lastName: '',
		phone: ''
	});

	const [errorMessage, setErrorMessage] = useState('');
	const [toast, setToast] = useState('');
	const [acceptedTerms, setAcceptedTerms] = useState(false);
	const navigate = useNavigate();
	const token = localStorage.getItem('authToken');

	useEffect(() => {
		if (token) navigate('/');
	}, [token, navigate]);
	
	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleRegister = async (e) => {
		e.preventDefault();

		if (formData.password !== formData.confirmPassword) {
			setErrorMessage('Hasła nie są identyczne');
			return;
		}

		if (!acceptedTerms) {
			setErrorMessage('Musisz zaakceptować regulamin sklepu');
			return;
		}

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
			});

			const data = await response.json();

			if (response.ok) {
				// ✅ USUNIĘTO: Nie wywołujemy już /api/mail/send-activation, 
				// ponieważ backend wysyła maila automatycznie przy rejestracji.

				setToast('Rejestracja zakończona sukcesem! Sprawdź swoją skrzynkę e-mail.');
				
				// Dajemy użytkownikowi 3 sekundy na przeczytanie Toasta przed przekierowaniem
				setTimeout(() => {
					navigate('/login');
				}, 3000);
			} else {
				setErrorMessage(data.message || 'Błąd rejestracji');
			}
		} catch (error) {
			setErrorMessage('Błąd połączenia z serwerem');
		}
	};

	return (
		<div className="auth-container">
			<h1>Rejestracja</h1>
			<form onSubmit={handleRegister}>
				<div className="input-group">
					<label>Imię</label>
					<input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
				</div>

				<div className="input-group">
					<label>Nazwisko</label>
					<input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
				</div>

				<div className="input-group">
					<label>Email</label>
					<input type="email" name="email" value={formData.email} onChange={handleChange} required />
				</div>

				<div className="input-group">
					<label>Numer telefonu</label>
					<input
						type="tel"
						name="phone"
						value={formData.phone}
						onChange={handleChange}
						required
						pattern="[0-9]{9}"
						title="Wprowadź 9-cyfrowy numer telefonu"
					/>
				</div>

				<div className="input-group">
					<label>Hasło</label>
					<input type="password" name="password" value={formData.password} onChange={handleChange} required />
				</div>

				<div className="input-group">
					<label>Powtórz hasło</label>
					<input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
				</div>

				{/* ✅ Akceptacja regulaminu */}
				<div className="input-group-regulamin">
					<input
						type="checkbox"
						checked={acceptedTerms}
						onChange={(e) => setAcceptedTerms(e.target.checked)}
					/>{' '}
					<label>
						Akceptuję{' '}
						<a href="/pdf/regulamin.pdf" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
							regulamin sklepu
						</a>
					</label>
				</div>

				{errorMessage && <p className="error-message">{errorMessage}</p>}

				<ButtonRegular type="submit" disabled={!acceptedTerms}>
					Zarejestruj się
				</ButtonRegular>

				{toast && <Toast message={toast} onClose={() => setToast('')} />}
			</form>

			<p>
				Masz już konto? <Link to="/login" className="switch-link">Zaloguj się</Link>
			</p>
		</div>
	);
};

export default PageRegister;
